var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-main"},[_c('section',{attrs:{"id":"xnax"}},[_c('left-bar'),_c(_vm.getInsideCurrentPage,{tag:"component"}),_c('right-bar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }